import axios from 'axios';
import { eventBus } from '../main';
import { store } from '../store/store';

const instance = axios.create();

instance.interceptors.request.use((c) => {
  eventBus.clearStatus();
  const config = c;
  config.headers = {
    credentials: 'same-origin',
    'X-XSRF-TOKEN': store.state.csrfToken,
  };
  config.headers.Accept = 'application/json;charset=UTF-8';
  if (config.method.toLowerCase() === 'post') {
    config.headers['Content-Type'] = 'application/x-www-form-urlencoded;charset=UTF-8';
  } else if (config.method.toLowerCase() === 'patch') {
    config.headers['Content-Type'] = 'application/json-patch+json';
  }
  config.baseURL = '/api';
  return config;
});

// Add a response interceptor, which sets csrf header and also handles errors.
instance.interceptors.response.use((response) => {
  const token = response.headers['x-xsrf-token'];
  if (token) {
    store.commit('setCsrfToken', token);
  }
  return response;
}, (error) => {
  if (error.response) {
    const token = error.response.headers['x-xsrf-token'];
    if (token) {
      store.commit('setCsrfToken', token);
    }
    // If the user needs to (re)authenticate. This will be true if the response status code == 401
    // OR
    // if the status code == 403 && the error message includes the keyword 'StateAuth' which is appended to the
    // error message in the ZuulErrorFilter when the 403 is due to an invalid user token.
    // Any other 403 would originate with ED and indicate the user is not authorized to perform an action.
    let doIdpAuth = false;
    const errorMessage = error.response.data.message;
    if (error.response.status === 403 || error.response.status === 401) {
      doIdpAuth = true;
    }
    if (doIdpAuth) {
      window.location = store.getters.casLoginServiceUrl;
    } else {
      eventBus.appStatus.statusCode = error.response.status;
      if (errorMessage) {
        eventBus.appStatus.statusMessage = errorMessage;
      } else {
        eventBus.appStatus.statusMessage = 'Unknown error occurred';
      }
      eventBus.displayStatus();
    }
  } else if (error.toString().includes('timeout')) {
    eventBus.appStatus.statusCode = 408;
    if (error.config.method === 'get') {
      eventBus.appStatus.statusMessage = 'Connection timeout occurred. Please try again in a few minutes.';
    } else {
      eventBus.appStatus.statusMessage = 'Connection timeout occurred. Updates may still complete successfully. ' +
        'Try refreshing your groups in a few minutes and check if the expected updates were applied.';
    }
    eventBus.displayStatus();
  }
  return Promise.reject(error);
});

export default instance;




// WEBPACK FOOTER //
// ./src/util/groups-axios.js